import React, { Component } from 'react';
import axios from '~/data/http/axios';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import CheckBox from '~/Common-Objects/UI/Forms/CheckBox/CheckBox'
import Column from '~/Common-Objects/Grids/Column/Column'
import Drawer from '~/Common-Objects/UI/Drawer/Drawer.jsx'
import HeaderText from '~/Common-Objects/Text/HeaderText/HeaderText'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import SubHeaderText from '~/Common-Objects/Text/SubHeaderText/SubHeaderText'
import CreateFieldDrawer from '~/pages/cp/subscribers/customfields/incAddCustomField';
import SelectFields from './selectFields'

class DynamicsFields extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            lookups: {
                contact: [],
                lead: []
            },
            customFields: [],
            mapping: {},
            fieldMapping: {
                contact: {},
                lead: {}
            },
            creating: {
                open: false
            }
        }

        this.getLookups = this.getLookups.bind(this)
        this.getLookupFields = this.getLookupFields.bind(this)
        this.mapCurrentSetup = this.mapCurrentSetup.bind(this)
        this.getCustomFields = this.getCustomFields.bind(this)
        this.updateMapping = this.updateMapping.bind(this)
        this.updateUpdateMappingFrom = this.updateUpdateMappingFrom.bind(this)
        this.updateUpdateMappingTo = this.updateUpdateMappingTo.bind(this)
        this.save = this.save.bind(this)
        this.createField = this.createField.bind(this)
        this.closeDrawer = this.closeDrawer.bind(this)
    }

    componentDidMount() {
        this.getLookups()
    }

    getLookups() {
        axios.get('/application/dynamics/lookups').then(response => {
            this.setState({
                lookups: response.data
            }, this.getCustomFields)
        })
    }

    getCustomFields() {
        axios.get('/customfield').then(response => {
            this.setState({
                customFields: response.data.CustomFields
            }, this.mapCurrentSetup)
        })
    }

    mapCurrentSetup() {
        var fieldMapping = this.state.fieldMapping;
        if (this.props.app.appSettings.lookups) {
            this.props.app.appSettings.lookups.contact.forEach(row => {
                fieldMapping.contact[row.field] = { checked: true, lookup: row.lookup, from: row.from, to: row.to }
                this.getLookupFields(row.lookup)
            })
            this.props.app.appSettings.lookups.lead.forEach(row => {
                fieldMapping.lead[row.field] = { checked: true, lookup: row.lookup, from: row.from, to: row.to }
                this.getLookupFields(row.lookup)
            })
        }
        this.setState({ fieldMapping, loading: false })
    }

    getLookupFields(lookup) {
        axios.get('/application/dynamics/lookups/' + lookup).then(response => {
            var mapping = this.state.mapping;
            mapping[lookup] = response.data.Fields
            this.setState({ mapping })
        })
    }

    updateMapping(type, lookup, ev) {
        var fieldMapping = this.state.fieldMapping;
        var mapping = fieldMapping[type]
        var name = ev.currentTarget.name
        if (ev.currentTarget.checked) {
            mapping[name] = { checked: true, from: '', field: lookup.target, to: '' }
        } else {
            delete mapping[name]
        }
        this.setState({ fieldMapping }, () => {
            if (!this.state.mapping[lookup.target]) {
                this.getLookupFields(lookup.target)
            }
        })
    }

    updateUpdateMappingFrom(type, ev) {
        var fieldMapping = this.state.fieldMapping;
        var mapping = fieldMapping[type];
        mapping[ev.currentTarget.name].from = ev.currentTarget.value;
        this.setState({ fieldMapping })
    }

    updateUpdateMappingTo(type, ev) {
        var fieldMapping = this.state.fieldMapping;
        var mapping = fieldMapping[type];
        mapping[ev.currentTarget.name].to = ev.currentTarget.value;
        this.setState({ fieldMapping })
    }

    createField(type, lookup) {
        var creating = this.state.creating
        creating.open = true;
        creating.type = type;
        creating.lookup = lookup
        this.setState({
            creating
        })
    }

    closeDrawer(field) {
        var creating = this.state.creating
        creating.open = false;
        if (field) {
            var customFields = this.state.customFields
            var fieldMapping = this.state.fieldMapping;
            var mapping = fieldMapping[creating.type];
            mapping[creating.lookup.name].to = field.fieldName;
            customFields.push(field)
            this.setState({ fieldMapping, customFields }, this.getCustomFields)
        }
        creating.type = '';
        creating.lookup = undefined;
        this.setState({
            creating
        })
    }

    save() {
        var binding = this.props.app
        // binding.appSettings.lookups = { contact: [], lead: [] };
        // var fieldMapping = this.state.fieldMapping;
        // Object.keys(fieldMapping.contact).forEach(prop => {
        //     binding.appSettings.lookups.contact.push({
        //         from: fieldMapping.contact[prop].from,
        //         lookup: fieldMapping.contact[prop].field,
        //         field: prop,
        //         to: fieldMapping.contact[prop].to
        //     })
        // })
        // Object.keys(fieldMapping.lead).forEach(prop => {
        //     binding.appSettings.lookups.lead.push({
        //         from: fieldMapping.lead[prop].from,
        //         lookup: fieldMapping.lead[prop].field,
        //         field: prop,
        //         to: fieldMapping.lead[prop].to
        //     })
        // })

        axios.put("/application/account/" + binding.id, binding).then(() => {
            return axios.put('/application/dynamics/fields')
        }).then(() => {
            return axios.get('/application/dynamics/picklists')
        }).then(this.props.onClose)
    }

    render() {
        if (this.state.loading) return <LoadingIcons iconType="2" />
        return (
            <div>
                <Row>
                    <Column xs={12}>
                        <HeaderText>Select Dynamics Fields to Include</HeaderText>
                    </Column>
                    <Column xs={12} margin={0}>
                        <SelectFields appBinding={this.props.app} />
                    </Column>
                    <Column xs={12}>
                        <Button text="Save" onClick={this.save} className="button-md outline primary" />
                    </Column>
                    {/* <Column xs={12}>
                        <HeaderText>Select Dynamics Joins to Include</HeaderText>
                    </Column>
                    <Column xs={12} md={6}>
                        <Paper className="primary">
                            <SubHeaderText>Contacts</SubHeaderText>
                            <Row>
                                <Column xs={12} margin={0}>
                                    <Row className="text-heavy">
                                        <Column xs={5}>Dynamics Object</Column>
                                        <Column xs={5}>From Dynamics Field</Column>
                                        <Column xs={2}></Column>
                                    </Row>
                                </Column>
                                {this.state.lookups.contact.map((lookup, index) => {
                                    return <Column key={index} xs={12} margin={0}>
                                        <Row>
                                            <Column xs={5}>
                                                <CheckBox checked={!!this.state.fieldMapping.contact[lookup.name]} name={lookup.name} onChange={ev => this.updateMapping('contact', lookup, ev)}>{lookup.displayName}</CheckBox>
                                            </Column>
                                            <Column xs={5} className="form-group">

                                                {!!this.state.fieldMapping.contact[lookup.name] && !this.state.mapping[lookup.target] && <span className="loading text-white">Loading</span>}
                                                {!!this.state.fieldMapping.contact[lookup.name] && !!this.state.mapping[lookup.target] && <Select placeholder="--Select--" data={this.state.mapping[lookup.target].map(f => {
                                                    return {
                                                        label: f.displayName,
                                                        value: f.name
                                                    }
                                                })} value={this.state.fieldMapping.contact[lookup.name].from} name={lookup.name} onChange={ev => this.updateUpdateMappingFrom('contact', ev)} />}
                                            </Column>
                                            <Column xs={2}>
                                                {!!this.state.fieldMapping.contact[lookup.name] && <Button text="Create" className="button-sml outline full-width" onClick={() => this.createField('contact', lookup)} />}
                                            </Column>
                                        </Row>
                                    </Column>
                                })}
                            </Row>
                        </Paper>
                    </Column>
                    <Column xs={12} md={6}>
                        <Paper className="secondary">
                            <SubHeaderText>Leads</SubHeaderText>
                            <Row>
                                <Column xs={12} margin={0}>
                                    <Row className="text-heavy">
                                        <Column xs={5}>Dynamics Object</Column>
                                        <Column xs={5}>From Dynamics Field</Column>
                                        <Column xs={2}></Column>
                                    </Row>
                                </Column>
                                {this.state.lookups.lead.map((lookup, index) => {
                                    return <Column key={index} xs={12} margin={0}>
                                        <Row>
                                            <Column xs={5}>
                                                <CheckBox checked={!!this.state.fieldMapping.lead[lookup.name]} name={lookup.name} onChange={ev => this.updateMapping('lead', lookup, ev)}>{lookup.displayName}</CheckBox>
                                            </Column>
                                            <Column xs={5} className="form-group">
                                                {!!this.state.fieldMapping.lead[lookup.name] && !this.state.mapping[lookup.target] && <span className="loading text-white">Loading</span>}
                                                {!!this.state.fieldMapping.lead[lookup.name] && !!this.state.mapping[lookup.target] && <Select placeholder="--Select--" data={this.state.mapping[lookup.target].map(f => {
                                                    return {
                                                        label: f.displayName,
                                                        value: f.name
                                                    }
                                                })} value={this.state.fieldMapping.lead[lookup.name].from} name={lookup.name} onChange={ev => this.updateUpdateMappingFrom('lead', ev)} />}
                                            </Column>
                                            <Column xs={2}>
                                                {!!this.state.fieldMapping.lead[lookup.name] && <Button text="Create" className="button-sml outline full-width" onClick={() => this.createField('lead', lookup)} />}
                                            </Column>
                                        </Row>
                                    </Column>
                                })}
                            </Row>
                        </Paper>
                    </Column>
                    <Column xs={12}>
                        <Button text="Save" onClick={this.save} className="button-md outline primary" />
                    </Column> */}
                </Row>
                {this.state.creating.open && <Drawer close={this.closeDrawer} standalone={true} showClose={true} clickOutside={true}>
                    <CreateFieldDrawer getCustomFields={this.closeDrawer} standalone={true} />
                </Drawer>}
            </div>
        );
    }
}

export default DynamicsFields;